export const SET_DESTINATIONS_VIEW = "SET_DESTINATIONS_VIEW";
export const SET_SELECTED_DESTINATION = "SET_SELECTED_DESTINATION";
export const SET_SELECTED_DESTINATIONS = "SET_SELECTED_DESTINATIONS";
interface ActionTypes {
  SET_DESTINATIONS_VIEW: boolean;
  SET_SELECTED_DESTINATION: number;
  SET_SELECTED_DESTINATIONS: string;
}

export const setDestinationsViewTrigger = {
  BUTTON_CLICK: "BUTTON_CLICK",
  DESTINATION_CLICK: "DESTINATION_CLICK",
} as const;

export type SetDestinationsViewTriggerType = typeof setDestinationsViewTrigger[keyof typeof setDestinationsViewTrigger];

export type SetDestinationsViewPayload = {
  show: boolean;
  trigger?: SetDestinationsViewTriggerType;
};

export interface MessageAction {
  type: keyof ActionTypes;
  payload: string | SetDestinationsViewPayload;
}

export function setDestinationsView(
  show: boolean,
  trigger?: SetDestinationsViewTriggerType
): DestinationsViewTypes {
  return {
    type: SET_DESTINATIONS_VIEW,
    payload: { show, trigger },
  };
}

export function setSelectedDestinations(
  destinations: string
): DestinationsViewTypes {
  return {
    type: SET_SELECTED_DESTINATIONS,
    payload: destinations,
  };
}

export type DestinationsViewTypes = MessageAction;
